import { PieValueType } from '@mui/x-charts-pro';
import { PieChartResponse } from 'api/reports-service/reports-service.types';
import { useChartDataWithTranslations } from 'components/charts/inc-charts.hooks';
import IncDonutChart from 'components/charts/inc-donut-chart/inc-donut-chart.component';
import { useSearchQueryContext } from 'components/search/search.hooks';
import { useTranslation } from 'react-i18next';

const BrandSignupAggregate = () => {
  const { t } = useTranslation();
  const {
    data,
    queryState: { isFetching },
  }: { data: PieChartResponse; queryState: any } = useSearchQueryContext(
    'brandSignupAggregate',
  );
  const translatedData = useChartDataWithTranslations(
    data?.data,
    label => `page.loyaltyPerformanceReport.newMembers.${label}.label`,
  );

  return (
    <IncDonutChart
      data={translatedData as PieValueType[]}
      title={t('page.loyaltyPerformanceReport.newMembers.label')}
      data-testid="BrandSignupAggregate.IncDonutChart"
      PieChartProps={{
        loading: isFetching,
        sx: {
          maxHeight: { xs: 'unset', lg: 190 },
        },
      }}
    />
  );
};

export default BrandSignupAggregate;
